import { ArrowLeft, Check, Compass } from "@phosphor-icons/react";

export function BackRow({ onBack, progress }) {
  return (
    <div className="flex items-center justify-between mb-5">
      <button
        type="button"
        data-testid="nm-back-btn"
        onClick={onBack}
        className="flex items-center gap-1.5 font-body text-sm text-cvc-ink-soft hover:text-cvc-ink"
      >
        <ArrowLeft size={16} weight="bold" /> Back
      </button>
      <p className="font-body text-[11px] tracking-[0.2em] uppercase text-cvc-ink-soft">{progress}</p>
    </div>
  );
}

export function OptionButton({ testId, selected, onClick, children, sub }) {
  return (
    <button
      type="button"
      data-testid={testId}
      onClick={onClick}
      aria-pressed={!!selected}
      className={`text-left px-5 py-4 rounded-xl border font-body text-base transition-colors
        ${selected
          ? "bg-cvc-navy text-cvc-cream border-cvc-navy"
          : "bg-white text-cvc-ink border-cvc-border hover:border-cvc-navy hover:bg-cvc-parchment"}`}
    >
      <span className="flex items-center gap-3">
        {selected && <Check size={18} weight="bold" className="shrink-0" />}
        <span>
          {children}
          {sub && <span className={`block text-sm mt-0.5 ${selected ? "text-cvc-cream/80" : "text-cvc-ink-soft"}`}>{sub}</span>}
        </span>
      </span>
    </button>
  );
}

export function HelpButton({ testId, label, onClick }) {
  return (
    <button
      type="button"
      data-testid={testId}
      onClick={onClick}
      className="text-left px-5 py-4 rounded-xl border border-dashed border-cvc-red/50 bg-cvc-parchment/60 font-body text-base text-cvc-red hover:bg-cvc-parchment hover:border-cvc-red transition-colors flex items-center gap-3"
    >
      <Compass size={18} weight="bold" className="shrink-0" /> {label}
    </button>
  );
}

export function SkipLink({ testId, onClick, label = "Skip" }) {
  return (
    <button
      type="button"
      data-testid={testId}
      onClick={onClick}
      className="font-body text-sm text-cvc-ink-soft underline underline-offset-4 hover:text-cvc-ink"
    >
      {label}
    </button>
  );
}

export function Disclaimer({ text, testId }) {
  return (
    <p data-testid={testId} className="mt-6 pt-4 border-t border-cvc-border font-body text-xs italic text-cvc-ink-soft/90 leading-relaxed">
      {text}
    </p>
  );
}
